import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList, LockKeyhole, ArrowLeft } from 'lucide-react';
import { useTheme, useThemeClasses } from '../hooks/useTheme';

export default function SessionsDesignerLockedPage() {
  const { isDark } = useTheme();
  const theme = useThemeClasses(isDark);
  return <main className={`flex min-h-screen items-center justify-center p-6 ${theme.bg} ${theme.textPrimary}`}>
    <section className={`w-full max-w-md rounded-3xl border p-8 text-center ${theme.card}`}>
      <div className="relative mx-auto mb-5 w-fit rounded-2xl bg-violet-500/15 p-4"><ClipboardList size={36} className="text-violet-400" /><LockKeyhole size={18} aria-hidden="true" className="absolute -bottom-1 -right-1 rounded-full bg-amber-300 p-0.5 text-amber-950" /></div>
      <h1 className="text-2xl font-bold">Session Designer</h1>
      <p className="mt-5 inline-block -rotate-3 rounded-lg border border-amber-100 bg-amber-300 px-4 py-2 text-sm font-bold text-amber-950 shadow-md">Coming soon</p>
      <p className={`mt-6 text-sm ${theme.textSecondary}`}>We’re getting this ready. Check back soon to design your training sessions.</p>
      <Link to="/" className="mt-6 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#493986] to-[#92a7e8] px-5 py-3 text-sm font-semibold text-white"><ArrowLeft size={16} />Back to dashboard</Link>
    </section>
  </main>;
}
